import http from './_http'

const crs = {
  get: (id) => http.get(`api/v3/uwss/crs/${id}`),
  list: (m) => http.post(`api/v3/uwss/crs/search`, m),
  add: (m) => http.post(`api/v3/uwss/crs/`, m),
  update: (m) => http.put(`api/v3/uwss/crs`, m),
  delete: (id) => http.delete(`api/v3/uwss/crs/${id}`),
}

const pattern = {
  get: (id) => http.get(`api/v3/uwss/pattern/${id}`),
  list: (m) => http.post(`api/v3/uwss/pattern/search`, m),
  bulkPublish: (m) => http.post(`api/v3/uwss/pattern/bulk/publish`, m),
  bulkUnpublish: (m) => http.post(`api/v3/uwss/pattern/bulk/unpublish`, m),
  add: (m) => http.post(`api/v3/uwss/pattern/`, m),
  update: (m) => http.put(`api/v3/uwss/pattern`, m),
  delete: (id) => http.delete(`api/v3/uwss/pattern/${id}`),
  download: (id) => http.get(`api/v3/uwss/pattern/${id}/download`),
}

const license = {
  add: (m) => http.post(`api/v3/license`, m),
  get: (id) => http.get(`api/v3/license/${id}`),
  list: (m) => http.post(`api/v3/license/search`, m),
  update: (m) => http.put(`api/v3/license`, m),
  delete: (id) => http.delete(`api/v3/license/${id}`),
}

const log_fetch = {
  get: (id) => http.get(`api/v3/uwss/fetch/${id}`),
  list: (m) => http.post(`api/v3/uwss/fetch/search`, m),
}

const basic = {
  pattern, crs, license, log_fetch
}
export default basic
export { pattern, crs, license, log_fetch }
